import cloc from "../../../assets/icons/clock.svg";
import calendar from "../../../assets/icons/calendar.svg";
import { Wrapper } from "./style";

export default ({ data }) => {
  const sectors = {
    1: "Ishlab-chiqarish",
    2: "Xizmat-ko'rsatish",
    3: "Tibbiyot",
    4: "Savdo-sotiq",
    5: "Ta'lim",
  };
  return (
    <Wrapper>
      <div className="wrap">
        <div className="card">
          <div className="date-title">F.I.SH</div>
          <div className="date">{data?.title}</div>
        </div>
        <div className="card">
          <div className="date-title">Telefon raqam</div>
          <div className="date">{data?.phone}</div>
        </div>
      </div>
      <div className="wrap">
        {data.industry_sector && (
          <div className="card">
            <div className="date-title">Faoliyat sohasi</div>
            <div className="date">{sectors[data.industry_sector]}</div>
          </div>
        )}
        {data.preffered_contact_time && (
          <div className="card">
            <div className="date-title">Qo‘g‘iroq vaqti</div>
            <div className="date">{data.preffered_contact_time}</div>
          </div>
        )}
      </div>
      {data.desc && (
        <div className="desc">
          <div className="date-title">Xabar matni</div>
          <div className="date">{data.desc}</div>
        </div>
      )}
      <div className="wrap">
        <div className="card">
          <div className="date-title">Bog‘lanish sanasi</div>
          <div className="date">
            <img src={calendar} alt="" /> {data?.date}
          </div>
        </div>
        <div className="card">
          <div className="date-title">Bog‘lanish vaqti</div>
          <div className="date">
            <img src={cloc} alt="" />
            {data?.hour}
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
